import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

export default function About() {
  return (
    <section id="about" className="home-about" aria-label="About Nexite">
      {/* Decorative animated background */}
      <div className="ha-bg" aria-hidden="true">
        <span className="ha-blob b1" />
        <span className="ha-blob b2" />
        <span className="ha-blob b3" />
        <span className="ha-grid-glow" />
      </div>

      <div className="ha-container">
        {/* Left: copy */}
        <div className="ha-col ha-copy">
          <span className="ha-pill">Innovation at Nexite</span>
          <h2 className="ha-title">Who We Are</h2>

          <p className="ha-body">
            Considering transformation in a fully connected, data‑driven era, NEXITE focuses on delivering
            cutting‑edge technology and specializes in turn‑key services to navigate the complexities of the
            modern digital world. We build smart, scalable designs by blending advanced technology,
            strategic insights, and creative expertise.
          </p>

          {/* Feature bullets */}
          <ul className="ha-features">
            <li>
              <div className="ha-icon">🔒</div>
              <div className="ha-ftext">
                <strong>Secure by design</strong>
                <span>Zero‑trust patterns, hardened edges, policy‑as‑code.</span>
              </div>
            </li>
            <li>
              <div className="ha-icon">⚡</div>
              <div className="ha-ftext">
                <strong>High performance</strong>
                <span>Deterministic latency and observable user experience.</span>
              </div>
            </li>
            <li>
              <div className="ha-icon">🧩</div>
              <div className="ha-ftext">
                <strong>Turn‑key delivery</strong>
                <span>From design to rollout—tested, verified, documented.</span>
              </div>
            </li>
            <li>
              <div className="ha-icon">🤝</div>
              <div className="ha-ftext">
                <strong>Human‑centered</strong>
                <span>Elegant, usable solutions that teams love to run.</span>
              </div>
            </li>
          </ul>

          {/* CTAs */}
          <div className="ha-actions">
            <Link to="/services" className="ha-btn ha-btn-primary" aria-label="Explore Services">
              <span className="shine" aria-hidden="true" />
              Explore Services
            </Link>
            <Link to="/about" className="ha-btn ha-btn-secondary" aria-label="Learn more about Nexite">
              Learn more
            </Link>
          </div>

          {/* Stats */}
          <div className="ha-stats">
            <div className="ha-stat">
              <div className="ha-num">50+</div>
              <div className="ha-lab">Projects Delivered</div>
            </div>
            <div className="ha-stat">
              <div className="ha-num">99.9%</div>
              <div className="ha-lab">Service Uptime</div>
            </div>
            <div className="ha-stat">
              <div className="ha-num">24/7</div>
              <div className="ha-lab">Support</div>
            </div>
            <div className="ha-stat">
              <div className="ha-num">5+</div>
              <div className="ha-lab">Years Innovating</div>
            </div>
          </div>
        </div>

        {/* Right: Visual stack */}
        <div className="ha-col ha-visual" aria-hidden="true">
          <div className="ha-card-stack">
            <div className="ha-card c1 hover-tilt">
              <div className="ha-card-head">
                <span className="ha-chip">AI</span>
                <span className="dot" />
              </div>
              <div className="ha-card-body">
                <div className="ha-emoji">🤖</div>
                <p>Analytics that see, learn, and alert in real time.</p>
              </div>
              <span className="card-shine" />
            </div>

            <div className="ha-card c2 hover-tilt">
              <div className="ha-card-head">
                <span className="ha-chip">Network</span>
                <span className="dot" />
              </div>
              <div className="ha-card-body">
                <div className="ha-emoji">📡</div>
                <p>Wi‑Fi 6/6E, SD‑WAN, and zero‑trust segmentation.</p>
              </div>
              <span className="card-shine" />
            </div>

            <div className="ha-card c3 hover-tilt">
              <div className="ha-card-head">
                <span className="ha-chip">Security</span>
                <span className="dot" />
              </div>
              <div className="ha-card-body">
                <div className="ha-emoji">🛡️</div>
                <p>Access, video, and policy unified for outcomes.</p>
              </div>
              <span className="card-shine" />
            </div>

            <div className="ha-orb o1" />
            <div className="ha-orb o2" />
          </div>
        </div>
      </div>

      <div className="ha-accent" aria-hidden="true" />
    </section>
  );
}